import { doAction, doResponseAction } from ".";

const GET_HEALTH_CHECK_DATA = 'GET_HEALTH_CHECK_DATA';
const GET_HEALTH_CHECK_DATA_SUCCESS = 'GET_HEALTH_CHECK_DATA_SUCCESS';
const GET_HEALTH_CHECK_DATA_FAILURE = 'GET_HEALTH_CHECK_DATA_FAILURE';

const GET_DOWNTIME_REPORT = 'GET_DOWNTIME_REPORT';
const GET_DOWNTIME_REPORT_SUCCESS = 'GET_DOWNTIME_REPORT_SUCCESS';
const GET_DOWNTIME_REPORT_FAILURE = 'GET_DOWNTIME_REPORT_FAILURE';

export {
    GET_HEALTH_CHECK_DATA,
    GET_HEALTH_CHECK_DATA_FAILURE,
    GET_HEALTH_CHECK_DATA_SUCCESS,
    GET_DOWNTIME_REPORT,
    GET_DOWNTIME_REPORT_FAILURE,
    GET_DOWNTIME_REPORT_SUCCESS,
}

// GET_HEALTH_CHECK_DATA
export const getHealthCheckData = (params, callback) => doAction(GET_HEALTH_CHECK_DATA, params, callback);
export const getHealthCheckDataSuccess = (data = {}) => doResponseAction(GET_HEALTH_CHECK_DATA_SUCCESS, data);
export const getHealthCheckDataFailure = (data = {}) => doResponseAction(GET_HEALTH_CHECK_DATA_FAILURE, data);

// GET_DOWNTIME_REPORT
export const getDowntimeReport = (params, callback) => doAction(GET_DOWNTIME_REPORT, params, callback);
export const getDowntimeReportSuccess = (data = {}) => doResponseAction(GET_DOWNTIME_REPORT_SUCCESS, data);
export const getDowntimeReportFailure = (data = {}) => doResponseAction(GET_DOWNTIME_REPORT_FAILURE, data);

